import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    position: 'relative',
    height: '100%',
    backgroundColor: $theme.colors.white,
    padding: '0 2rem',
    color: $theme.colors.black,
    paddingBottom: '5rem'
}))
